import { trpc } from "../trpc";

export function useConnectionStats() {
  const { data, isLoading, isError } =
    trpc.authentication.connectionStats.useQuery();

  return {
    personal: data?.personal,
    managed: data?.managed,
    total: data?.total,
    isLoading,
    isError,
  };
}
